// Testi dell’interfaccia in italiano. Ripiego: es.
export default {
  common: {
    close: "Chiudi",
    retry: "Riprova",
    cancel: "Annulla",
    reset: "Ripristina",
    change: "Cambia",
  },
  roles: {
    teacher: "Docente",
    moderator: "Moderatore",
    student: "Studente",
  },
  controlBar: {
    micDisabledByTeacher: "Microfono disattivato dal docente",
    micOn: "Attiva microfono",
    micOff: "Disattiva microfono",
    micSettings: "Impostazioni microfono",
    camDisabledByTeacher: "Videocamera disattivata dal docente",
    noCamera: "Nessuna videocamera rilevata",
    camOn: "Attiva videocamera",
    camOff: "Disattiva videocamera",
    camSettings: "Impostazioni videocamera",
    screenUnsupported: "Il tuo browser mobile non consente la condivisione dello schermo",
    screenDisabledByTeacher: "Condivisione schermo disattivata dal docente",
    screenShare: "Condividi schermo",
    screenStop: "Interrompi condivisione schermo",
    screenSwitch: "Cambia schermo condiviso",
    captionOptions: "Lingua e dimensione dei sottotitoli",    captionsReadIn: "Leggo i sottotitoli in",
    captionsHint: "Cambia solo {you}: quello che si dice in classe ti arriva tradotto in questa lingua. Ognuno sceglie la propria.",
    captionsHintYou: "il tuo schermo",
    captionsSpeakIn: "Parlo in",
    captionsSpeakHint: "Così viene trascritto {mic}. Solo la tua voce: ognuno indica la propria.",
    captionsSpeakHintMic: "il tuo microfono",
    captionSize: "Dimensione dei sottotitoli",
    captionsOn: "Attiva i sottotitoli in diretta",
    captionsOff: "Disattiva i sottotitoli in diretta",
    captionsHide: "Nascondi i sottotitoli",
    captionsShow: "Mostra i sottotitoli",
    leave: "Esci dalla sessione",
    more: "Altre opzioni",
  },
  captions: {
    untranslated: "Non ancora tradotto · {lang}",
    size: {
      sm: "Piccolo",
      md: "Medio",
      lg: "Grande",
      xl: "Molto grande",
    },
  },
  sessionMenu: {
    title: "Menu della sessione",
    section: "Sessione",
    code: "Codice",
    codeHide: "Nascondi codice",
    codeShow: "Mostra codice",
    copyInvite: "Copia il link d'invito",
    recordStart: "Registra la sessione",
    recordStop: "Interrompi registrazione ({duration})",
    recordPause: "Metti in pausa la registrazione",
    recordResume: "Riprendi la registrazione",
    recordPauseHint: "Ciò che è in pausa non viene registrato",
    recordPausedHint: "In pausa: non si sta registrando",
    subtitles: "Sottotitoli automatici",
    subtitlesOn: "Alla fine verrà generato un file .vtt",
    subtitlesOff: "Disattivati",
    fullscreen: "Schermo intero",
    fullscreenExit: "Esci da schermo intero",
    endSession: "Termina la sessione",
    endSessionHint: "La lezione finisce per tutti",
    endSessionConfirm: "La lezione finisce per tutti e la stanza resta chiusa. Per riaprirla bisogna cambiare l'orario dell'attività.",
    endSessionCancel: "Annulla",
    endSessionConfirmYes: "Termina",
  },
  sidePanel: {
    title: "Pannello della sessione",
    open: "Apri il pannello della sessione",
    close: "Chiudi il pannello",
    back: "Indietro",
    tabs: {
      chat: "Chat",
      attendees: "Partecipanti",
      transcript: "Trascrizione",
      share: "Condividi contenuti",
      settings: "Le mie impostazioni",
    },
  },
  transcript: {
    note: "In {lang}, la tua lingua di lettura.",
    copy: "Copia",
    copyTitle: "Copia la trascrizione",
    copied: "Copiata",
    emptyOff: "I sottotitoli in diretta sono disattivati. Quando un moderatore li attiva, qui resta tutto ciò che viene detto.",
    emptyIdle: "Non è stato ancora detto nulla. Le frasi compariranno qui man mano che si parla.",
    jumpToLatest: "Vai all'ultimo",
  },
  hand: {
    chatMicBlocked: "🔒 {by} ha bloccato il microfono di {name}",
    chatMicAllowed: "🔓 {by} ha consentito il microfono di {name}",
    chatCamBlocked: "🔒 {by} ha bloccato la fotocamera di {name}",
    chatScreenBlocked: "🔒 {by} ha bloccato la condivisione dello schermo di {name}",
    chatCamAllowed: "🔓 {by} ha consentito la fotocamera di {name}",
    chatScreenAllowed: "🔓 {by} ha consentito la condivisione dello schermo di {name}",
    chatExpelled: "⛔ {by} ha espulso a {name}",
    chatGranted: "🎤 {by} ha dato la parola a {name}",
    chatRevoked: "🔇 {by} ha tolto la parola a {name}",
    chatCamGranted: "📷 {by} ha attivato la fotocamera di {name}",
    chatCamRevoked: "🚫 {by} ha disattivato la fotocamera di {name}",
    grantCam: "Attiva la sua fotocamera",
    revokeCam: "Disattiva la sua fotocamera",
    camGranted: "L'insegnante ha attivato la tua fotocamera: ora puoi accenderla.",
    camTaken: "L'insegnante ha disattivato la tua fotocamera.",
    raise_: "Alza la mano",
    lower: "Abbassa la mano",
    chatRaised: "✋ {name} ha alzato la mano",
    notifyRaised: "✋ {name} ha alzato la mano",
    grant: "Dai la parola",
    revoke: "Togli la parola",
    lowerFor: "Abbassa la sua mano",
    options: "Vedi nei partecipanti",
    gone: "Non è più nella stanza",
    youHaveTheFloor: "Hai la parola: attiva il microfono per parlare.",
    floorTaken: "Il tuo turno di parola è terminato.",
    raisedYou: "Hai alzato la mano. Il moderatore ti darà la parola.",
    loweredYou: "Hai abbassato la mano.",
    hasFloor: "Ha la parola",
    raisedBadge: "Mano alzata",
    raisedCount: "{n} con la mano alzata",
  },
  chat: {
    title: "Chat della riunione",
    emptyTitle: "I messaggi compariranno qui",
    emptyHint: "Sii il primo a inviarne uno",
    placeholder: "Invia un messaggio a tutti",
    hint: "Invio per inviare, Maiusc+Invio per andare a capo",
    roleTeacher: "PROF",
    roleModerator: "MOD",
  },
  share: {
    screenStart: "Condividi schermo",
    screenStop: "Interrompi la condivisione dello schermo",
    screenUnsupported: "Non disponibile in questo browser",
    disabledByTeacher: "Disattivato dal docente",
    screenSwitch: "Cambia schermo condiviso",
    screenSwitchHint: "Scegli un'altra finestra o scheda",
    pdfStart: "Presenta un PDF",
    pdfStop: "Interrompi la presentazione PDF",
    pdfHint: "Condividi un documento pagina per pagina",
    empty: "Non c'è nulla che tu possa condividere in questa sessione.",
  },
  participants: {
    lockedNote: "I permessi in grigio vengono dalle impostazioni della sessione in Moodle e si possono cambiare solo lì.",
    setInMoodle: "Si modifica nelle impostazioni della sessione in Moodle",
    title: "Partecipanti",
    classroomControls: "Controlli dell'aula",
    muteOnJoin: "Disattiva il microfono all'ingresso",
    allowStudentVideo: "Consenti le videocamere degli studenti",
    allowStudentAudio: "Consenti i microfoni degli studenti",
    allowScreenShare: "Consenti la condivisione dello schermo",
    allowChat: "Consenti la chat",
    allowRecording: "Consenti la registrazione",
    muteAll: "Disattiva tutti i microfoni",
    camerasOff: "Spegni le videocamere",
    search: "Cerca un partecipante",
    you: "Tu",
    group: {
      teacher: "Docenti",
      moderator: "Moderatori",
      hands: "Turno di parola",
      student: "Studenti",
    },
    micAllow: "Consenti il microfono",
    micBlock: "Blocca il microfono",
    camAllow: "Consenti la videocamera",
    screenAllow: "Consenti la condivisione dello schermo",
    camBlock: "Blocca la videocamera",
    screenBlock: "Blocca la condivisione dello schermo",
    makeModerator: "Rendi moderatore",
    makeTeacher: "Rendi docente",
    expel: "Espelli il partecipante",
    empty: "Nessun partecipante trovato",
  },
  settings: {
    language: "Lingua dell'interfaccia",
    microphone: "Microfono",
    micUnnamed: "Microfono senza nome",
    noMics: "Nessun microfono rilevato",
    audioSettings: "Impostazioni audio",
    volume: "Volume",
    noiseSuppression: "Soppressione del rumore",
    advanced: "Impostazioni avanzate",
    agc: "Potenzia il microfono (AGC)",
    agcHint: "Livella la tua voce alla fonte così tutti ti sentono allo stesso volume (come su Discord). Attivo per impostazione predefinita; disattivalo solo se amplifica troppo il rumore di fondo.",
    normalize: "Normalizza il volume degli altri",
    normalizeHint: "Di solito non serve: ogni microfono si livella già alla fonte. Attivalo solo se una persona in particolare si sente ancora troppo alta o troppo bassa.",
    peakLimit: "Limite dei picchi",
    off: "spento",
    micTest: "Prova il microfono",
    micTestStop: "Interrompi la prova",
    micLevel: "Livello del microfono",
    micTestPrivate: "Durante la prova nessun altro ti sente.",
    camera: "Videocamera",
    camUnnamed: "Videocamera senza nome",
    noCams: "Nessuna videocamera rilevata",
    videoFilters: "Filtri video",
    filterQuality: "Qualità del filtro",
    filterQualityLabel: "Qualità del filtro: {level}",
    mirrorOn: "Attiva l'effetto specchio",
    mirrorOff: "Disattiva l'effetto specchio",
    mirrorHint: "Ribalta la videocamera in orizzontale",
    bgImage: "Immagine di sfondo",
    bgImageRemove: "Rimuovi l'immagine di sfondo",
    bgImageHint: "Si applica con Rimuovi sfondo, Sfondo sfocato o Chroma",
    pipRounded: "Arrotonda i bordi del PiP",
    pipSquare: "Togli i bordi arrotondati del PiP",
    pipHint: "Angoli arrotondati sulla videocamera",
    chat: "Chat",
    chatMute: "Nascondi le notifiche dei messaggi",
    chatMuteHint: "Nessun suono né notifiche per i nuovi messaggi",
    teacherMode: "Modalità Docente",
    overlayMode: "Modalità sovrapposizione",
    overlayHint: "Mette la tua videocamera sopra lo schermo condiviso",
  },
  filters: {
    title: "Filtri video",
    open: "Apri i filtri",
    close: "Chiudi i filtri",
    none: {
      name: "Nessun filtro",
      description: "Il video originale, senza effetti",
    },
    backgroundRemoval: {
      name: "Rimuovi sfondo",
      description: "Elimina lo sfondo e lascia solo la sagoma",
    },
    backgroundBlur: {
      name: "Sfoca lo sfondo",
      description: "Sfoca lo sfondo mantenendo nitida la persona",
    },
    chromaGreen: {
      name: "Chroma key verde",
      description: "Ritaglia i pixel verdi (green screen)",
    },
    quality: {
      basic: {
        name: "Base",
        description: "15 fps · leggero (CPU bassa)",
      },
      medium: {
        name: "Medio",
        description: "20 fps · equilibrato",
      },
      high: {
        name: "Alto",
        description: "30 fps · fluido",
      },
      max: {
        name: "Massimo",
        description: "30 fps · modello più preciso",
      },
    },
  },
  grid: {
    moreParticipants: "partecipanti",
    participantGone: "Disconnesso",
    netLost: "Connessione persa",
    netWeak: "Connessione debole",
    netNone: "Nessuna connessione",
    micMuted: "Microfono disattivato",
    camOff: "Videocamera disattivata",
    screenOf: "Schermo di {name}",
    yourScreen: "Il tuo schermo",
  },
  audioMenu: {
    subtitle: "Regola il volume",
    noAudio: "Questo partecipante non ha audio disponibile.",
    screen: "Schermo condiviso",
    mic: "Microfono",
    autoNormalize: "Normalizzazione automatica",
    auto: "Auto",
  },
  overlay: {
    drag: "Trascina per spostare",
    position: "Cambia posizione",
    hide: "Nascondi la sovrapposizione",
  },
  pdf: {
    title: "Presentazione PDF",
    whiteboard: "Lavagna",
    maximize: "Ingrandisci",
    restore: "Ripristina le dimensioni",
    color: "Colore",
    width: "Spessore",
    fill: "Riempi le forme",
    undo: "Annulla (Ctrl+Z)",
    redo: "Ripeti (Ctrl+Y)",
    clear: "Pulisci la tela",
    deleteSelected: "Elimina l'elemento selezionato (Canc)",
    change: "Cambia PDF",
    changeCurrent: "Cambia PDF (attuale: {file})",
    load: "Carica un PDF",
    loading: "Caricamento del PDF...",
    loadError: "Impossibile caricare il PDF",
    emptyHint: "Carica un PDF per iniziare.",
    whiteboardHintA: "Disegna liberamente sulla tela principale.",
    whiteboardHintB: "Gli studenti vedono solo ciò che è sullo schermo, videocamera inclusa.",
    prevPage: "Pagina precedente",
    nextPage: "Pagina successiva",
    rendering: "Rendering della pagina...",
    zoomIn: "Zoom avanti",
    zoomOut: "Zoom indietro",
    zoomReset: "Ripristina zoom (100%)",
    panHint: "Tieni premuto Ctrl e trascina per spostare la vista",
    tools: {
      select: "Seleziona",
      pen: "Matita",
      line: "Linea",
      rect: "Rettangolo",
      circle: "Cerchio",
      text: "Testo",
      eraser: "Gomma",
    },
    textPrompt: "Testo:",
  },
  room: {
    callTime: "Tempo in chiamata",
    latency: "Latenza della tua connessione (andata e ritorno)",
    connectionError: "Errore di connessione",
    recTitle: "Questa sessione viene registrata",
    recPausedTitle: "Registrazione in pausa: non si sta registrando",
    recPausedBadge: "PAUSA",
    netPoor: "Connessione debole",
    netUnstable: "Connessione instabile",
    noMediaAccess: {
      camera: "Nessun accesso alla fotocamera — controlla i permessi del browser",
      mic: "Nessun accesso al microfono — controlla i permessi del browser",
      both: "Nessun accesso a fotocamera e microfono — controlla i permessi del browser",
    },
    connecting: "Connessione...",
    reconnecting: "Riconnessione...",
    reconnectAttempt: "Tentativo {n}",
    connectionLost: "Connessione persa",
    reconnectFailed: "Riconnessione automatica non riuscita. Controlla la connessione a Internet e premi il pulsante.",
    reconnect: "Riconnetti",
    recordingInProgress: "Hai una registrazione in corso ({duration}).",
    saveRecording: "Salva la registrazione",
    confirmLeave: "Vuoi davvero uscire dalla riunione?",
    unloadWarning: "La registrazione è ancora in corso. Fermala prima di uscire.",
    route: {
      turn: "Traffico inoltrato da un server TURN (rete restrittiva)",
      stun: "Connessione diretta tra pari (scoperta tramite STUN)",
      direct: "Connessione diretta sulla stessa rete locale",
      directLabel: "Diretta",
      pending: "Determinazione del percorso di connessione…",
    },
    notify: {
      captionsMicBlocked: "La tua voce non viene ancora trascritta: fai clic in un punto qualsiasi dello schermo per attivarla.",
      captionsOn: "Sottotitoli in diretta attivati. Scegli la tua lingua e la loro dimensione nel pulsante dei sottotitoli della barra in basso; tutto ciò che è stato detto è nella scheda Trascrizione.",
      captionsOff: "Sottotitoli in diretta disattivati.",
      serverRecDone: "Registrazione terminata. Sarà importabile in Moodle tra qualche minuto.",
      serverRecDoneLocal: "Registrazione terminata. È in corso il download sul tuo computer.",
      recDownloading: "Registrazione pronta: download sul tuo computer…",
      recDownloadingParts: "Registrazione pronta in {n} parti: download sul tuo computer…",
      lostButRecording: "Connessione alla stanza persa. La registrazione locale continua.",
      subtitlesGenerating: "Generazione dei sottotitoli della registrazione…",
      subtitlesFailed: "Non è stato possibile generare i sottotitoli",
      subtitleModel: "Caricamento del modello dei sottotitoli…",
      subtitleModelPct: "Caricamento del modello dei sottotitoli… {pct}%",
      recUnsupported: "Il tuo browser non può registrare la lezione. Usa Chrome, Edge o un altro browser basato su Chromium.",
      connectError: "Impossibile connettersi",
      micMuted: "Microfono disattivato",
      micOn: "Microfono attivato",
      audioError: "Impossibile modificare l'audio",
      camOn: "Videocamera attivata",
      camOff: "Videocamera disattivata",
      videoError: "Impossibile modificare il video",
      screenOn: "Condivisione dello schermo in corso",
      screenOff: "Condivisione dello schermo interrotta",
      screenError: "Impossibile condividere lo schermo",
      screenSwitched: "Schermo condiviso aggiornato",
      screenSwitchError: "Impossibile cambiare lo schermo condiviso",
      filterUnavailable: "Il filtro non è stato caricato (modello di IA non disponibile). Controlla la connessione o le restrizioni del browser (CSP / ad-blocker). Dettagli nella console.",
      filterError: "Impossibile applicare il filtro",
      pdfError: "Impossibile avviare la presentazione PDF",
      micSwitched: "Microfono cambiato",
      micSwitchError: "Impossibile cambiare microfono",
      camSwitched: "Videocamera cambiata",
      camSwitchError: "Impossibile cambiare videocamera",
      recSaved: "Registrazione salvata. Download del file in corso...",
      recSaveError: "Impossibile salvare la registrazione",
      recStoppedLocal: "Registrazione interrotta. Download del file…",
      recStartedLocal: "Registrazione locale avviata",
      recStartError: "Impossibile avviare la registrazione",
      recMergePending: "La registrazione è stata salvata ma non è ancora stato possibile assemblarla; verrà ritentato automaticamente",
      recStopping: "Interruzione della registrazione…",
      recStoppedServer: "Registrazione interrotta. Il server elabora il video, i sottotitoli e la chat: puoi chiudere la finestra.",
      recStopError: "Impossibile confermare l'interruzione della registrazione. Potrebbe essere ancora in corso — riprova.",
      endSessionError: "Impossibile confermare la chiusura della sessione. Potrebbe essere ancora aperta — riprova.",
      recStartedServer: "Registrazione della stanza avviata",
      recStarting: "Avvio della registrazione della stanza…",
      recServerBusy: "Impossibile registrare: il server di registrazione è al massimo della capacità perché altre stanze stanno registrando. Riprova tra qualche minuto.",
      recResumed: "Registrazione ripresa",
      recPaused: "Registrazione in pausa. Premi Riprendi la registrazione per continuare nello stesso file.",
      participantMicBlocked: "Microfono bloccato per il partecipante",
      participantMicAllowed: "Il partecipante può di nuovo attivare il microfono",
      participantCamBlocked: "Videocamera bloccata per il partecipante",
      participantScreenBlocked: "Condivisione dello schermo bloccata per il partecipante",
      participantCamAllowed: "Il partecipante può di nuovo attivare la videocamera",
      participantScreenAllowed: "Il partecipante può di nuovo condividere lo schermo",
      expelling: "Espulsione del partecipante...",
      settingError: "Impossibile aggiornare l'impostazione",
      settingUpdated: "Impostazioni aggiornate",
      allMuted: "Tutti gli studenti sono stati silenziati",
      allCamsOff: "Tutte le videocamere degli studenti sono state disattivate",
      linkCopied: "Link d'invito copiato",
      linkCopyError: "Impossibile copiare il link",
    },
  },
  notify: {
    joinedAs: "Sei entrato come {name}",
    reconnected: "Connessione ripristinata",
    reconnectFailed: "Riconnessione non riuscita. Controlla la connessione a Internet.",
    beingRecorded: "Questa sessione viene registrata.",
    roleNotGranted: "Sei entrato come studente: il tuo link di accesso non attesta il ruolo di docente. Avvisa l'amministratore del campus.",
    roomDataError: "Impossibile elaborare i dati della stanza",
    participantJoined: "{name} è entrato",
    participantLeft: "{name} è uscito",
    recordingStarted: "La registrazione della sessione è iniziata.",
    recordingStopped: "Registrazione interrotta",
    recordingPaused: "Registrazione in pausa: da ora non viene registrato nulla.",
    recordingResumed: "Registrazione ripresa.",
    participantExpelled: "{name} è stato espulso",
    forcedMicOff: "Il moderatore ha disattivato il tuo microfono",
    forcedCamOff: "Il moderatore ha disattivato la tua videocamera",
    forcedScreenOff: "Il moderatore ha interrotto la tua condivisione dello schermo",
    forcedMicBlocked: "Il moderatore ha bloccato il tuo microfono",
    forcedMicAllowed: "Il moderatore ti consente di nuovo il microfono: attivalo quando vuoi",
    forcedCamBlocked: "Il moderatore ha bloccato la tua videocamera",
    cameraUnusable: "Quella videocamera non funziona su questo dispositivo; è stata rimossa dall'elenco",
    forcedScreenBlocked: "Il moderatore ti ha bloccato la condivisione dello schermo",
    forcedCamAllowed: "Il moderatore ti consente di nuovo la videocamera: attivala quando vuoi",
    forcedScreenAllowed: "Il moderatore ti consente di nuovo la condivisione dello schermo",
    youWereExpelled: "Sei stato espulso dalla stanza: {reason}",
    mutedAllBy: "{by} ha silenziato tutti gli studenti",
    camsOffAllBy: "{by} ha disattivato tutte le videocamere degli studenti",
    settingsUpdatedBy: "{by} ha aggiornato le impostazioni della stanza",
    youAreNow: "Ora sei {role}",
    meshMode: "Sei in modalità compatibilità (mesh): potresti non vedere né sentire gli altri. Ricarica la pagina togliendo \"?sfu=0\" dall'indirizzo.",
    sfuReconnecting: "Riconnessione al server video…",
    sfuLost: "Connessione al server video persa. Nuovo tentativo…",
    sfuDown: "Il server video non risponde. Stiamo riprovando; non vedrai né sentirai nessuno finché non torna.",
    sfuDownDev: "Il server video di prova è spento: avvialo con «dev.bat up». La stanza si collegherà da sola appena parte.",
    screenNotAllowed: "Il docente non consente la condivisione dello schermo",
  },
  supervisor: {
    hiddenBanner: "Sei nascosto come supervisore: nessuno ti vede né ti sente.",
    reveal: "Mostrami",
    revealed: "Ora sei visibile alla sala",
  },
  join: {
    otherRoomTitle: "Sei già in un'altra sessione: {room}",
    otherRoomHint: "Esci da quella sessione per entrare in questa. Appena esci, potrai entrare da qui.",
    supervisorNotice: "Entri come supervisore: nessuno ti vedrà né ti sentirà finché non decidi di mostrarti.",
    sfuDownTitle: "Il server video non risponde",
    sfuDownHint: "Puoi entrare, ma non vedrai né sentirai nessuno finché non torna. Riprova tra qualche minuto.",
    sfuDownDevHint: "Le VM di prova sono spente: «dev.bat up» e attendi un paio di minuti. Questo avviso sparisce da solo.",
    loadingRoom: "Caricamento della stanza…",
    classroomNotice: "Aula virtuale: entrerai con microfono e fotocamera disattivati. Per intervenire, alza la mano e l’insegnante li attiverà.",
    lockedByClassroom: "Disattivato nell’aula virtuale finché l’insegnante non lo attiva",
    title: "Tutto pronto per entrare?",
    subtitle: "Controlla audio e video prima di entrare",
    roomCode: "Codice della riunione",
    roomCodePlaceholder: "Inserisci un codice",
    yourName: "Il tuo nome",
    yourNamePlaceholder: "Inserisci il tuo nome",
    mediaWarning: "Impossibile accedere alla videocamera o al microfono",
    mediaWarningHint: "Puoi entrare lo stesso, oppure riprovare",
    cameraFilter: "Filtro della videocamera",
    mirror: "Modalità specchio",
    join: "Entra ora",
    joining: "Ingresso in corso...",
    errorRoomRequired: "Il codice della stanza è obbligatorio",
    errorNameRequired: "Il nome è obbligatorio",
    errorGeneric: "Impossibile entrare nella stanza",
  },
  home: {
    heroTitle: "Lezioni in diretta,{break}senza {highlight}.",
    heroTitleHighlight: "complicazioni",
    heroSubtitle: "Piattaforma educativa di streaming in {hd}, con lavagna collaborativa e trascrizione con IA. Senza pagamenti, senza registrazioni, senza complicazioni. Semplificati la vita.",
    heroSubtitleHd: "alta definizione",
    heroLive: "In diretta",
    create: "Crea una lezione",
    join: "Entra in una lezione",
    featureHd: "Video in HD",
    featureHdTip: "Alta Definizione",
    featureHdDesc: "Streaming video in alta definizione con WebRTC peer-to-peer",
    featureBoard: "Lavagna collaborativa",
    featureBoardDesc: "Disegno e collaborazione in tempo reale con più partecipanti",
    featureAi: "Trascrizione con IA",
    featureAiDesc: "Trascrizione automatica e analisi dei contenuti con ML",
    featureRecording: "Registrazione dello schermo",
    featureRecordingDesc: "Registra facilmente lo schermo o la videocamera del docente durante la lezione",
    featureChat: "Chat in diretta",
    featureChatDesc: "Messaggistica istantanea con cronologia persistente",
    featureBreakout: "Stanze di lavoro",
    featureBreakoutDesc: "Stanze separate per il lavoro in piccoli gruppi",
  },
  create: {
    title: "Crea una nuova lezione",
    subtitle: "Configura la tua nuova sessione video",
    roomName: "Nome della lezione",
    roomNamePlaceholder: "es. Matematica avanzata",
    roomType: "Tipo di sessione",
    types: {
      classroom: "Aula virtuale",
      meeting: "Riunione",
      webinar: "Webinar",
      recording: "Registrazione",
    },
    maxParticipants: "Numero massimo di partecipanti",
    teacherNamePlaceholder: "Nome del docente",
    settings: "Impostazioni della lezione",
    submit: "Crea la lezione",
    creating: "Creazione...",
    error: "Impossibile creare la lezione",
    cardNumber: "N.",
    chooseOne: "scegline uno",
    tickAll: "spunta quelle che vuoi",
  },
  pip: {
    close: "Chiudi la vista piccola",
  },
  sessionEnded: {
    title: "Sessione terminata",
    lead: "Hai lasciato la sessione. Puoi rientrare o chiudere questa finestra.",
    leadRemoved: "Un moderatore ti ha rimosso dalla sessione. Puoi chiudere questa finestra.",
    titleClosed: "La sessione è terminata",
    titleFinished: "La lezione è finita",
    leadFinished: "Chi teneva la sessione l'ha conclusa. Puoi chiudere questa finestra.",
    titleNotOpen: "La sessione non è ancora iniziata",
    leadClosed: "La sessione si è conclusa all'orario previsto e non è più possibile entrare. Se pensi che sia ancora in corso, avvisa chi la tiene.",
    leadNotOpen: "Non puoi ancora entrare: la stanza apre poco prima dell'orario di inizio. Riaprila dal campus quando inizia.",
    titleTimeLimit: "La tua connessione è stata chiusa",
    leadTimeLimit: "Eri nella stanza da 12 ore di fila e oltre quel tempo la connessione si chiude da sola. Se sei ancora a lezione, rientra.",
    rejoin: "Rientra",
    close: "Chiudi la finestra",
    closeHint: "Il browser non chiude questa scheda automaticamente: chiudila tu.",
  },
}
